"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../constants");
var getSizes_1 = __importDefault(require("../../lib/getSizes"));
var getImageMimeType_1 = __importDefault(require("./getImageMimeType"));
var getSrcSet_1 = __importDefault(require("./getSrcSet"));
var getFormats_1 = __importDefault(require("./getFormats"));
var getPictureSources = function (options) {
    var imageDetails = options.imageDetails, filename = options.filename, src = options.src, effects = options.effects;
    var formats = getFormats_1.default(options);
    var sizes = getSizes_1.default(options);
    return formats.flatMap(function (format) {
        var entries = Object.entries(sizes);
        return entries.map(function (_a) {
            var _b = __read(_a, 2), breakpoint = _b[0], size = _b[1];
            return ({
                id: format + "-" + breakpoint + "-" + size,
                type: getImageMimeType_1.default(format),
                media: constants_1.MediaBreakpoints[breakpoint],
                srcSet: getSrcSet_1.default({ imageDetails: imageDetails, filename: filename, src: src, size: size, effects: effects, format: format }),
            });
        });
    });
};
exports.default = getPictureSources;
//# sourceMappingURL=getPictureSources.js.map